export default __webpack_public_path__ + "static/media/data-base.36a6994e.svg";